import React, { memo, FC } from 'react'
import type { ReactNode } from 'react'
import PageonLoadWrapper from './styled'
interface IProps {
  children?: ReactNode
}

const PageonLoad: FC<IProps> = () => {
  return (
    <PageonLoadWrapper>
      <div id="root-loading"></div>
    </PageonLoadWrapper>
  )
}

export default memo(PageonLoad)
